import React from 'react'
import { css } from 'aphrodite'
import { Row, Col } from 'reactstrap'

/* eslint-disable */
import { inject, observer } from 'mobx-react'
/* eslint-enable */

import styleA from './style'
import styleB from '../../style'

import Container from '../../partials/Container'

import RevenueTable from '../../partials/RevenueTable'

import access from '../../../../utils/access'
import uRevenue from '../../../../utils/revenue'
import uStats from '../../../../utils/stats'

const THEME_LIST = [
  { name: 'Regular', label: 'Regular' },
  { name: 'ColorBlind', label: 'ColorBlind' }
]

@inject('Auth', 'User', 'Community', 'Stats', 'Payment', 'Config')
@observer
export class CommunityRevenue extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      active: {},
      editor: {}
    }
  }

  componentWillMount () {
    const comId = this.props.match.params.comId
    const _findReports = () => {
      return setTimeout(() => {
        if (this.props.Auth.token.pending || this.props.User.me.pending) {
          return _findReports()
        }

        Promise.all([
          ...(!this.props.Community.all.slice().find(c => c.id === comId)
            ? [this.props.Community.getCommunity(comId)]
            : []),
          this.props.Stats.getRevenueReport(comId),
          this.props.Payment.getRevenueReport(comId),
          this.props.Payment.getTransactionReport(comId)
        ]).catch(() => this.props.history.push(`/dashboard/community`))
      }, 500)
    }

    _findReports()
  }

  onAddClick (e) {
    const date = new Date()

    this.setState({
      ...this.state,
      active: { active: true },
      editor: {
        date: date.toISOString().slice(0, 10),
        amount: 0
      }
    })
  }

  onFormSubmit (e) {
    e.preventDefault()

    const comId = this.props.match.params.comId
    this.props.Payment.postManualRevenueReport(comId, {
      total: this.state.editor.amount,
      date: this.state.editor.date
    })
  }

  onInputChange (e) {
    this.setState({
      ...this.state,
      editor: {
        ...this.state.editor,
        [e.target.name]: e.target.value
      }
    })
  }

  renderRevenueForm () {
    if (!access.adminCom(this.props.User.me.permissions || {})) {
      return null
    }

    if (!this.state.active.active) {
      return <NavigationArea onAddClick={this.onAddClick.bind(this)} />
    }

    return (
      <RevenueForm
        theme={THEME_LIST[this.props.Config.theme]}
        editor={this.state.editor}
        onSubmit={this.onFormSubmit.bind(this)}
        onInputChange={this.onInputChange.bind(this)}
      />
    )
  }

  render () {
    const comId = this.props.match.params.comId
    const stats = (this.props.Stats.revenue[comId] || []).reduce(
      uStats.reduceSumStats,
      []
    )
    const revenue = (this.props.Payment.revenue[comId] || []).reduce(
      uRevenue.reduceSumRevenue,
      []
    )

    const transactions = (this.props.Payment.transactions[comId] || []).slice()

    return (
      <Container {...this.props}>
        <Row>
          <Col xs='12' lg='5'>
            <h2 className={css(styleB.headers.h2)}>Revenue</h2>
          </Col>
          <Col>{this.renderRevenueForm()}</Col>
        </Row>
        <Row>
          <RevenueTable
            theme={THEME_LIST[this.props.Config.theme]}
            active={this.state.active}
            stats={stats}
            revenue={revenue}
            transactions={transactions}
          />
        </Row>
      </Container>
    )
  }
}

const NavigationArea = props => {
  return (
    <Row>
      <Col />
      <Col>
        <span
          className={css(styleB.buttons.button, styleB.buttons.red)}
          onClick={props.onAddClick}
        >
          Add new
        </span>
      </Col>
    </Row>
  )
}

const RevenueForm = props => {
  return (
    <form
      onSubmit={props.onSubmit}
      className={`row ${css(
        styleA.form.container,
        styleA[props.theme.name]
          ? styleA[props.theme.name].form.container
          : null
      )}`}
    >
      <Col
        className={css(
          styleA.form.inputWrapper,
          styleA[props.theme.name]
            ? styleA[props.theme.name].form.inputWrapper
            : null
        )}
      >
        <input
          type={`text`}
          name={`date`}
          placeholder={`date`}
          value={props.editor.date}
          onChange={props.onInputChange}
          className={css(
            styleA.form.input,
            styleA[props.theme.name]
              ? styleA[props.theme.name].form.input
              : null
          )}
        />
      </Col>
      <Col
        className={css(
          styleA.form.inputWrapper,
          styleA[props.theme.name]
            ? styleA[props.theme.name].form.inputWrapper
            : null
        )}
      >
        <input
          type={`text`}
          name={`amount`}
          placeholder={`amount`}
          value={props.editor.amount}
          onChange={props.onInputChange}
          className={css(
            styleA.form.input,
            styleA[props.theme.name]
              ? styleA[props.theme.name].form.input
              : null
          )}
        />
      </Col>
      <Col
        xs='3'
        className={css(
          styleA.form.inputWrapper,
          styleA[props.theme.name]
            ? styleA[props.theme.name].form.inputWrapper
            : null
        )}
      >
        <button
          className={css(
            styleB.buttons.button,
            styleB.buttons.red,
            styleA.form.button
          )}
        >
          Save
        </button>
      </Col>
    </form>
  )
}

export default CommunityRevenue



// WEBPACK FOOTER //
// ./src/components/Community/Revenue/Main/index.js